import { Flex, RootScreen, Spinner } from '@banhala/ui-kit';
import { HomeContents } from './components';
import { Suspense } from 'react';
import { HomeHeader } from './components/HomeHeader';
import { HomeScrollContext } from './context/HomeScrollContext';
import { useHomeScroll } from './context/useHomeScroll';

export const HomeScreen = () => {
  const { headerVisible, onScrollY } = useHomeScroll();

  return (
    <RootScreen>
      <HomeScrollContext.Provider value={{ headerVisible, onScrollY }}>
        <HomeHeader />

        <Flex flex={1}>
          <Suspense fallback={<Spinner />}>
            <HomeContents />
          </Suspense>
        </Flex>
      </HomeScrollContext.Provider>
    </RootScreen>
  );
};
